import {CartItem, getItemTotal, useCartItem} from '@/app/cartContext';
import {CloseOutlined} from '@ant-design/icons';
import {Divider, Drawer} from 'antd';
import styles from './cart-product-card.module.css';
import {useControlledCounter} from '@/ui/use-counter/use-counter';
import {Button} from '@/ui/button/button';
import {Modal} from '@/ui/modal/modal';
import {ModalContent} from '@/components/modal-content/modal-content';
import {useBoolean} from '@/utils/use-boolean';
import {ImageWithStub} from '@/ui/image-with-stub/image-with-stub';
import {useInfo} from '@/app/infoContext';

export const CartProductCard = ({item}: {item: CartItem}) => {
    const {isMobile} = useInfo();
    const {incrementQuantity, decrementQuantity, updateItem} = useCartItem(item);
    const {component} = useControlledCounter(item?.quantity, incrementQuantity, decrementQuantity);

    const [isModalOpen, openModal, closeModal] = useBoolean(false);

    if (!item) {
        return;
    }

    const onRemoveAdditional = (id: number) => {
        updateItem(item, {
            ...item,
            additional: item.additional?.filter((item) => item.id !== id),
        });
    };

    const onUpdateClick = (product: CartItem) => {
        updateItem(item, product);
        closeModal();
    };

    return (
        <div className={`${styles.cardWrapper} ${isMobile ? styles.isMobile : ''}`}>
            <div className={styles.cardContent}>
                <ImageWithStub
                    src={item.imageUrl}
                    alt={item.name}
                    width={100}
                    height={97}
                    style={{borderRadius: '8px', objectFit: 'cover'}}
                />
                <div>
                    <div className={styles.name}>{item.name}</div>
                    <div className={styles.chips}>
                        {item.additional?.map((add) => (
                            <CategoryChip
                                key={add.id}
                                name={add.name}
                                onClickClose={() => onRemoveAdditional(add.id)}
                            />
                        ))}
                    </div>
                    {isMobile && <div className={styles.price}>{getItemTotal(item) * item.quantity} ₽</div>}
                </div>
            </div>
            {!isMobile && <Divider style={{margin: '0'}} />}
            <div className={`${styles.footer} ${isMobile ? styles.isMobile : ''}`}>
                {!isMobile && <div className={styles.price}>{getItemTotal(item) * item.quantity} ₽</div>}
                <div className={`${styles.button} ${isMobile ? styles.isMobile : ''}`}>
                    <Button type={'default'} size="s" onClick={openModal}>
                        Изменить
                    </Button>
                </div>

                {component}
            </div>
            {isMobile && <Divider style={{margin: '0'}} />}
            {isMobile ? (
                <Drawer open={isModalOpen} onClose={closeModal} size="large">
                    <ModalContent id={item.id} onAccept={onUpdateClick} item={item} isMobile />
                </Drawer>
            ) : (
                <Modal isOpen={isModalOpen} onClose={closeModal}>
                    <ModalContent id={item.id} onAccept={onUpdateClick} item={item} />
                </Modal>
            )}
        </div>
    );
};

const CategoryChip = ({name, onClickClose}: {name: string; onClickClose: () => void}) => {
    return (
        <span className={styles.chip}>
            <CloseOutlined style={{opacity: '0.5'}} onClick={onClickClose} />
            {name}
        </span>
    );
};
